import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getBlogCategoryApi = createAsyncThunk("client/blog-category-list", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/blogs/v1/blog-category-list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("get blog-category-list response", response.data);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch blog-category-list");
  }
});
